import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { useTranslation } from 'react-i18next';


// 🟢 Основний компонент для завантаження файлів
const AddIncomingTab = () => {
    const { t } = useTranslation();
  

  const [allData, setAllData] = useState({ Uber: [], Bolt: [] });
  const navigate = useNavigate(); // ✅ Викликаємо useNavigate всередині компонента

  const handleUpload = (service) => {
    if (allData[service].length === 0) {
      console.warn(`⚠️ Немає даних для ${service}!`);
      return;
    }

    navigate(`/admin/incoming-preview/${service}/`, { state: { data: allData[service] } });
  };

  return (
    <div>
      <h4>{t("addServiceData")}</h4>
      <BoltUpload allData={allData} setAllData={setAllData} handleUpload={handleUpload} />
      <UberUpload allData={allData} setAllData={setAllData} handleUpload={handleUpload} />      
    </div>
  );
};

// 🟢 Завантаження Uber
const UberUpload = ({ allData, setAllData, handleUpload }) => {
  const { t } = useTranslation();
  const handleFileUpload = (event) => {
    processFile(event, "Uber", allData, setAllData);
  };

  return (
    <div className="mb-4">
      <h5>Uber</h5>
      <input type="file" className="form-control" accept=".xls,.xlsx" onChange={handleFileUpload} />
      <button className="btn btn-success mt-2" onClick={() => handleUpload("Uber")}>
        {t("upload")} Uber
      </button>
    </div>
  );
};

// 🟢 Завантаження Bolt
const BoltUpload = ({ allData, setAllData, handleUpload }) => {
  const { t } = useTranslation();
  const handleFileUpload = (event) => {
    processFile(event, "Bolt", allData, setAllData);
  };

  return (
    <div className="mb-4">
      <h5>Bolt</h5>
      <input type="file" className="form-control" accept=".xls,.xlsx" onChange={handleFileUpload} />
      <button className="btn btn-success mt-2" onClick={() => handleUpload("Bolt")}>
      {t("upload")} Bolt
      </button>
    </div>
  );
};

// 🟢 Функція для зчитування XLS/XLSX файлів
const processFile = (event, service, allData, setAllData) => {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: "array" });

    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];

    const jsonData = XLSX.utils.sheet_to_json(sheet);
    console.log(`📂 Дані з ${service}:`, jsonData);

    // Додаємо дані у загальний масив
    setAllData((prev) => ({ ...prev, [service]: jsonData }));
  };
  reader.readAsArrayBuffer(file);
};

export default AddIncomingTab;
